module.exports = __webpack_public_path__ + "assets/img/image_03.eae05829.png";